import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatChipsModule } from '@angular/material/chips';
import { OcppExpectedConfiguration, OcppExpectedConfigurationApiService } from '../../api/ocpp-expected-configuration-api.service';
import { take } from 'rxjs';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-ocpp-expected-configuration-page',
  templateUrl: './ocpp-expected-configuration-page.component.html',
  styleUrls: ['./ocpp-expected-configuration-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatChipsModule,
    MatTooltipModule,
  ]
})
export class OcppExpectedConfigurationPageComponent implements OnInit {
  searchFormGroup = new FormGroup({
    key: new FormControl(''),
    vendor: new FormControl(''),
    model: new FormControl(''),
    version: new FormControl(''),
  });
  createFormGroup = new FormGroup({
    key: new FormControl('', [Validators.required]),
    value: new FormControl('', [Validators.required]),
    vendor: new FormControl(''),
    model: new FormControl(''),
    version: new FormControl(''),
  });

  public configurationCreationFormVisible = false;

  public ocppExpectedConfigurations: OcppExpectedConfiguration[] = [];

  constructor(private ocppExpectedConfigurationApiService: OcppExpectedConfigurationApiService) { }

  ngOnInit() {
  }

  search(mode: 'all' | 'profile' = 'all') {
    this.ocppExpectedConfigurationApiService.searchOcppExpectedConfiguration(
      mode,
      this.searchFormGroup.value.key ?? undefined,
      this.searchFormGroup.value.vendor ?? undefined,
      this.searchFormGroup.value.model ?? undefined,
      this.searchFormGroup.value.version ?? undefined
    ).pipe(take(1)).subscribe((ocppExpectedConfigurations) => {
      this.ocppExpectedConfigurations = ocppExpectedConfigurations;
    });
  }

  editConfiguration(config: OcppExpectedConfiguration) {
    this.ocppExpectedConfigurationApiService.updateOcppExpectedConfiguration(config.id ?? '', config).pipe(take(1)).subscribe(() => {
      this.search();
    });
  }

  deleteConfiguration(config: OcppExpectedConfiguration) {
    this.ocppExpectedConfigurationApiService.deleteOcppExpectedConfiguration(config.id ?? '').pipe(take(1)).subscribe(() => {
      this.search();
    });
  }

  showConfigurationCreationForm() {
    this.configurationCreationFormVisible = true;
  }

  create() {
    if (!this.createFormGroup.valid) {
      return;
    }
    const newConfig: OcppExpectedConfiguration = {
      ...this.createFormGroup.value
    } as OcppExpectedConfiguration;
    if (!newConfig.vendor) {
      newConfig.vendor = undefined;
    }
    if (!newConfig.model) {
      newConfig.model = undefined;
    }
    if (!newConfig.version) {
      newConfig.version = undefined;
    }
    this.ocppExpectedConfigurationApiService.createOcppExpectedConfiguration(newConfig).pipe(take(1)).subscribe(() => {
      this.search();
      this.configurationCreationFormVisible = false;
    });
  }
}
